import ApiService from "@/services/ApiService";

export default {
  getSellOff(label) {
    return ApiService.axios.get(`/selloffs/${label}`);
  }
};
